import React from "react";
import styles from "./zodiac.module.css";
import {Page} from "../../components/page/page";
import {useSelector} from "react-redux";
import {singsImages} from "../../../../util";
import {signDescriptions} from "./signDescription";

const ZodiacPage = () => {
    const state = useSelector((store) => store.future);
    const zodiacSign = state.zodiacSign || 'Aries' //TODO так нельзя, Проверить в ленде в стор не передается zodiacSign, поэтому ошибка
    const gender = state.gender || 'Female' //TODO так нельзя, Проверить в ленде в стор не передается gender, поэтому ошибка
    console.log('don`t show correct zodiac sign ', zodiacSign)
    console.log('don`t show correct gender ', gender)


    return (
        <Page title="" nextPageLink="../love-language" currentStep="12">
            <div>
                <img
                    src={singsImages[state.zodiacSign]}
                    className={styles.sign_image}
                    alt={state.zodiacSign}
                />
                <h2 className={styles.sign}>{state.gender} {state.zodiacSign}</h2>
                {/* <p className={styles.sign_date}>{signDescriptions[state.zodiacSign]["signDate"]}</p> */}
                <p className={styles.sign_date}>{signDescriptions[zodiacSign].signDate}</p>
                <div className={styles.description}>
                    {/* {signDescriptions[state.zodiacSign][state.gender].map((el, i) =>
                        <p><span>{el.split(" ")[0]}</span>{el.slice(el.split(" ")[0].length)}</p>
                    )} */}
                    {signDescriptions[zodiacSign][gender].map((el, i) =>
                        <p><span>{el.split(" ")[0]}</span>{el.slice(el.split(" ")[0].length)}</p>
                    )}
                </div>
            </div>
        </Page>
    );
};

export {ZodiacPage};
